import "./styles.css";
import ProgressBar from "react-bootstrap/ProgressBar";
import Fade from "react-reveal/Fade";
function Skills() {
  return (
    <section id="skills" class="skills section-bg px-5">
      <div class="container px-5">
        <div class="section-title">
          <h2>Skills</h2>
        </div>

        <div class="row skills-content">
          <div class="col-lg-6" data-aos="fade-up">
            <div class="progress">
              <span class="skill">
                HTML <i class="val">75%</i>
              </span>
              <div class="progress-bar-wrap">
              <Fade left><ProgressBar animated now={75} /></Fade>
              </div>
            </div>

            <div class="progress">
              <span class="skill">
                NODE JS <i class="val">90%</i>
              </span>
              
                <div class="progress-bar-wrap">
                <Fade left><ProgressBar animated now={90} /> </Fade>
                </div>
             
            </div>
            <div class="progress">
              <span class="skill">
                REACT JS <i class="val">80%</i>
              </span>
             
              <div class="progress-bar-wrap">
              <Fade left> <ProgressBar animated now={80} />   </Fade>
              </div>
           
            </div>

            <div class="progress">
              <span class="skill">
                CSS <i class="val">60%</i>
              </span>
             
              <div class="progress-bar-wrap">
              <Fade left> <ProgressBar animated now={60} />  </Fade>
              </div>
            
            </div>

            <div class="progress">
              <span class="skill">
                JavaScript <i class="val">85%</i>
              </span>
              
              <div class="progress-bar-wrap">
              <Fade left><ProgressBar animated now={85} />   </Fade>
              </div>
           
            </div>

            <div class="progress">
              <span class="skill">
                PANDAS <i class="val">80%</i>
              </span>
             
              <div class="progress-bar-wrap">
              <Fade left><ProgressBar animated now={80} /></Fade>
              </div>
              
            </div>
            <div class="progress">
              <span class="skill">
                Django <i class="val">85%</i>
              </span>
             
              <div class="progress-bar-wrap">
              <Fade left><ProgressBar animated now={85} /> </Fade>
              </div>
             
            </div>
          </div>

          <div class="col-lg-6" data-aos="fade-up" data-aos-delay="100">
            <div class="progress">
              <span class="skill">
                PYTHON <i class="val">85%</i>
              </span>
            
              <div class="progress-bar-wrap">
              <Fade left> <ProgressBar animated now={85} />{" "} </Fade>
              </div>
             
              
            </div>

            <div class="progress">
              <span class="skill">
                MACHINE LEARNINGS<i class="val">68%</i>
              </span>
             
              <div class="progress-bar-wrap">
              <Fade left> <ProgressBar animated now={68} />{" "}   </Fade>
              </div>
           
            </div>

            <div class="progress">
              <span class="skill">
                GIT<i class="val">80%</i>
              </span>
           
              <div class="progress-bar-wrap">
              <Fade left> <ProgressBar animated now={80} />{" "}</Fade>
              </div>
              
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Skills;
